import React from 'react'
import cx from 'classnames'
import { useAppDispatch } from 'reduxTyped'
import { Icon, l, Lozenge } from '@manychat/manyui'

import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'

import cm from './styles.module.css'

export const KnowledgeTypesList = () => {
  const dispatch = useAppDispatch()

  const openKnowledgeEditor = (entryType: KnowledgeEntryType) => {
    dispatch(
      AiAutomationLayoutActions.currentViewReplaced({
        view: SidebarViewType.KNOWLEDGE_EDITOR,
        payload: {
          newEntryType: entryType,
        },
      }),
    )

    AiAutomationAnalytics.logKnowledgeEditorOpened({
      source: 'automation_empty_state',
      entry_state: 'new',
      entry_type: entryType,
    })
  }

  return (
    <ul className={cm.entryOptions}>
      <li className={cm.entryOption}>
        <Icon.Link className={cm.entryOption__icon} size={20} />

        <h3 className="m-t text-subheading">{l.translate('Add a link')}</h3>

        <div className={cx('text-sm', cm.entryOption__description)}>
          {l.translate('AI will pull all relevant info from the linked page')}
        </div>

        <button
          onClick={() => openKnowledgeEditor(KnowledgeEntryType.LINK)}
          className={cm.entryOption__button}
          aria-label={l.translate('Create link entry')}
        />
      </li>

      <li className={cm.entryOption}>
        <Icon.BuilderText className={cm.entryOption__icon} size={20} />

        <h3 className="m-t text-subheading">{l.translate('Write a text')}</h3>

        <div className={cx('text-sm', cm.entryOption__description)}>
          {l.translate('Share all necessary info so AI is context-aware')}
        </div>

        <button
          onClick={() => openKnowledgeEditor(KnowledgeEntryType.TEXT)}
          className={cm.entryOption__button}
          aria-label={l.translate('Create text entry')}
        />
      </li>

      <li className={cm.entryOption}>
        <div className="d-flex justify-between">
          <Icon.Text className={cm.entryOption__icon} size={20} />

          <Lozenge type="soon" />
        </div>

        <h3 className="m-t text-subheading">{l.translate('Add file')}</h3>

        <div className={cx('text-sm', cm.entryOption__description)}>
          {l.translate('Upload a PDF, DOCX, TXT, HTML')}
        </div>

        <button
          onClick={() => openKnowledgeEditor(KnowledgeEntryType.FILE)}
          disabled
          className={cm.entryOption__button}
          aria-label={l.translate('Create file entry')}
        />
      </li>
    </ul>
  )
}
